var _path, _path2, _path3, _g, _path4, _path5, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1273_4427)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.7035 31.1673C57.3275 29.2832 53.4379 28.2091 49.2972 28.2091C36.352 28.2091 25.8577 38.7033 25.8577 51.6485C25.8581 64.5934 36.3523 75.0878 49.2972 75.088C62.2423 75.088 72.7365 64.5936 72.7367 51.6485C72.7367 48.1777 71.9822 44.883 70.6285 41.9196L79.2111 42.5804C80.08 45.4506 80.5494 48.4948 80.5494 51.6485C80.5492 68.9085 66.5578 82.8997 49.2979 82.9C32.0376 82.9 18.0445 68.9081 18.0443 51.6478C18.0445 34.3877 32.037 20.395 49.2972 20.395C53.0641 20.395 56.6757 21.0614 60.0198 22.2829L60.7035 31.1673Z",
    fill: "url(#paint0_linear_1273_4427)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1714 47.6144C46.2647 49.5214 46.2646 52.6128 48.1714 54.5198C50.0783 56.4267 53.1696 56.4265 55.0767 54.5198L63.0379 46.5586C63.6249 48.1435 63.9466 49.8574 63.9466 51.6464C63.9466 59.7371 57.3875 66.2959 49.2969 66.2961C41.2061 66.2961 34.6473 59.7373 34.6472 51.6464C34.6472 43.5557 41.2061 36.9968 49.2969 36.9968C52.0193 36.9969 54.568 37.7401 56.7519 39.0338L48.1714 47.6144Z",
    fill: "url(#paint1_linear_1273_4427)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1273_4427",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 36,
    width: 30,
    height: 31
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1714 47.616C46.2647 49.523 46.2646 52.6144 48.1714 54.5213C50.0783 56.4283 53.1696 56.4281 55.0767 54.5213L63.0379 46.5602C63.6249 48.1451 63.9466 49.859 63.9466 51.648C63.9466 59.7387 57.3875 66.2975 49.2969 66.2977C41.2061 66.2977 34.6473 59.7388 34.6472 51.648C34.6472 43.5572 41.2061 36.9983 49.2969 36.9984C52.0193 36.9985 54.568 37.7417 56.7519 39.0354L48.1714 47.616Z",
    fill: "url(#paint2_linear_1273_4427)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1273_4427)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1273_4427)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.7908,
    cy: 46.4095,
    rx: 9.71358,
    ry: 9.64472,
    transform: "rotate(60 55.7908 46.4095)",
    fill: "white",
    fillOpacity: 0.8
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4099 38.6159L67.7071 37.6485L53.5145 51.841C52.7517 52.6037 51.5152 52.6037 50.7524 51.841C49.9896 51.0783 49.9897 49.8417 50.7524 49.0789L64.9456 34.8857L63.9789 26.1849L76.4092 13.7546L77.6521 24.9427L88.8402 26.1856L76.4099 38.6159Z",
    fill: "url(#paint3_linear_1273_4427)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1273_4427",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 13,
    width: 26,
    height: 26
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4089 38.6163L65.2209 37.3733L63.9779 26.1853L76.4082 13.755L77.6512 24.943L88.8392 26.186L76.4089 38.6163Z",
    fill: "url(#paint4_linear_1273_4427)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1273_4427)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1273_4427)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 21.9995,
    r: 9,
    fill: "white",
    fillOpacity: 0.6
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1273_4427",
    x: 34.1274,
    y: 24.7114,
    width: 43.3271,
    height: 43.3961,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_1273_4427"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1273_4427",
    x: 62.2,
    y: 2.19945,
    width: 39.6,
    height: 39.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.4,
    result: "effect1_foregroundBlur_1273_4427"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1273_4427",
    x1: 178.215,
    y1: 30.1617,
    x2: 177.236,
    y2: 98.4949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DD0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A6CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1273_4427",
    x1: 33.0476,
    y1: 64.9644,
    x2: 58.6165,
    y2: 28.9368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#269AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783654,
    stopColor: "#D873FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1273_4427",
    x1: 33.0476,
    y1: 64.966,
    x2: 62.3414,
    y2: 24.3862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#269AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836538,
    stopColor: "#DD87FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1273_4427",
    x1: 95.6873,
    y1: 10.6289,
    x2: 39.042,
    y2: 58.4842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB3543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1273_4427",
    x1: 89.0998,
    y1: 16.8952,
    x2: 60.8023,
    y2: 42.5973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB3543"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1273_4427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature3);
export default __webpack_public_path__ + "static/media/feature3.62d463c94bbea6fe41ebe8cd059cfeb6.svg";
export { ForwardRef as ReactComponent };